import Cookies from 'js-cookie';
import CONSTANTS from './Constants';


var USER_KEY = 'user';
var ORG_ID_KEY = 'org_id';

export function GetUser(){
  var user = Cookies.get(USER_KEY);
  if(user){
    user = JSON.parse(user);
    return user;
  }
  /*
  return {
    email:'chris@binderdrop.com',
    name:"Chris O'Brien",
    company_name:"BinderDrop",
  };
  */
  return null;
}


export function SetUser(user){
  Cookies.set(USER_KEY, JSON.stringify(user));
  if(user.org_id){
    console.log(user.org_id);
    Cookies.set(ORG_ID_KEY, user.org_id);
  }
}


export function GetOrgID(){
  return Cookies.get(ORG_ID_KEY);
}

var ORG_KEY = 'org';
export function GetOrg(){
  var org = Cookies.get(ORG_KEY);
  if(org){
    org = JSON.parse(org);
    return org;
  }
  return null;
}
export function SetOrg(org){
  Cookies.set(ORG_KEY, JSON.stringify(org));
}

export function RemoveUser(){
  Cookies.remove(USER_KEY);
  Cookies.remove(RECENTS_KEY);
  Cookies.remove(ORG_ID_KEY);
  Cookies.remove(ORG_KEY);
}


var RECENTS_KEY = 'recents';
export function GetRecents(){
  var recents = Cookies.get(RECENTS_KEY);
  if(recents){
    return JSON.parse(recents);
  }
  return null;
}


export function AddRecent(item){
  var recents = GetRecents() || [];
  var _newRecents = [];
  _newRecents[0] = item;
  
  recents.forEach(r => {
    if((r.id != item.id || r.type != item.type) && _newRecents.length < 10){
      _newRecents.push(r);
    }
  });

  Cookies.set(RECENTS_KEY, JSON.stringify(_newRecents));
}


export function StringToColor(s){
    if(!s) return CONSTANTS.COLORS.BLACK;

    
    s = s.toUpperCase();
    var num = s.charCodeAt(0);
    return NumToColor(num)
}

export function ShrinkNumber(num){
  if(!num) return 0;
  if(num >= 1000000000000){
    return Math.round((num / 1000000000000) * 10) / 10 + "T";
  }
  if(num >= 1000000000){
    return Math.round((num / 1000000000) * 10) / 10 + "B";
  }
  if(num >= 1000000){
    return Math.round((num / 1000000) * 10) / 10 + "M";
  }
  if (num >= 1000){
    return Math.round((num / 1000) * 10) / 10 + "K";
  }
  return num;
}


export function NumToColor(num) {
    switch(num % 7){
      case 0:
        return CONSTANTS.COLORS.ORANGE;
      case 1:
        return CONSTANTS.COLORS.PURPLE;
      case 2:
        return CONSTANTS.COLORS.RED;
      case 3:
        return CONSTANTS.COLORS.BLUE;
      case 4:
        return CONSTANTS.COLORS.GREEN;
      case 5:
        return CONSTANTS.COLORS.YELLOW;
      case 6:
        return CONSTANTS.COLORS.GREY;
    }
    return CONSTANTS.COLORS.BLACK;
}


export function SetChartDefaults(defaults){
    defaults.responsive = true;
    defaults.maintainAspectRatio = false;
    defaults.elements.bar.backgroundColor = [CONSTANTS.COLORS.YELLOW, CONSTANTS.COLORS.BLUE, CONSTANTS.COLORS.GREEN, CONSTANTS.COLORS.RED, CONSTANTS.COLORS.ORANGE, CONSTANTS.COLORS.PURPLE];
    defaults.elements.bar.borderColor = [CONSTANTS.COLORS.YELLOW, CONSTANTS.COLORS.BLUE, CONSTANTS.COLORS.GREEN, CONSTANTS.COLORS.RED, CONSTANTS.COLORS.ORANGE, CONSTANTS.COLORS.PURPLE];
    defaults.elements.arc.backgroundColor = [CONSTANTS.COLORS.YELLOW, CONSTANTS.COLORS.BLUE, CONSTANTS.COLORS.GREEN, CONSTANTS.COLORS.RED, CONSTANTS.COLORS.ORANGE, CONSTANTS.COLORS.PURPLE];
    defaults.elements.arc.borderColor = [CONSTANTS.COLORS.YELLOW, CONSTANTS.COLORS.BLUE, CONSTANTS.COLORS.GREEN, CONSTANTS.COLORS.RED, CONSTANTS.COLORS.ORANGE, CONSTANTS.COLORS.PURPLE];
}

export function sortFunctionPremium(a,b){
  if(a.totalPremium && !b.totalPremium) return -1;
  if(b.totalPremium && !a.totalPremium) return 1;
  return (b.totalPremium - a.totalPremium);
}

/**/